module.exports = __webpack_public_path__ + "img/title.8776531c.png";